module.exports = __webpack_public_path__ + "img/icone-wheat.a7f77ee4.svg";